
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { CameraFormValues } from "@/types/inventory";
import { useTranslation } from "@/hooks/useTranslation";
import { useState } from "react";

interface CameraNotesFieldProps {
  form: UseFormReturn<CameraFormValues>;
}

export function CameraNotesField({ form }: CameraNotesFieldProps) {
  const { t } = useTranslation();
  const [charCount, setCharCount] = useState(form.getValues("notes")?.length || 0);
  const maxChars = 100;

  return (
    <FormField
      control={form.control}
      name="notes"
      render={({ field }) => (
        <FormItem>
          <FormLabel>{t('notes')}</FormLabel>
          <FormControl>
            <Textarea 
              placeholder={t('notes_placeholder')} 
              className="resize-none" 
              rows={3} 
              {...field} 
              value={field.value || ""}
              maxLength={maxChars}
              onChange={(e) => {
                // Limit to 100 characters
                const value = e.target.value;
                if (value.length <= maxChars) {
                  field.onChange(value);
                  setCharCount(value.length);
                }
              }}
            />
          </FormControl>
          <div className="text-xs text-muted-foreground text-right mt-1">
            {charCount}/{maxChars}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
